import { render, staticRenderFns } from "./HomeContact.vue?vue&type=template&id=06faa028&scoped=true&"
var script = {}
import style0 from "./HomeContact.vue?vue&type=style&index=0&id=06faa028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faa028",
  null
  
)

export default component.exports